package one.healthium.health_log.ui.models

import one.healthium.domain.health_log.models.HealthLogAnswerModel
import one.healthium.domain.health_log.models.HealthLogQuestionModel
import androidx.compose.runtime.Immutable

@Immutable
data class HealthLogQuestionUiModel(
    val model: HealthLogQuestionModel,
    val selectedOption: HealthLogAnswerModel?,
) {
    val id: String = model.id
    val kind: String = model.kind
    val question: String? = model.question
    val options: List<HealthLogAnswerModel> = model.answers
}
